import Vue from "vue";
import axios from "axios";

const host = process.env.VUE_APP_API_SERVER;
const path = "/pri/checkSession";

export default {
  check() {
    let jwt = Vue.prototype.$session.get("jwt");
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return axios
      .get(host + path)
      .then((response) => {
        let res = response.data.data;
        const filterItems = (arr, query) => {
          return arr.filter(el => el.toLowerCase().indexOf(query.toLowerCase()) !== -1)
        }
        //res = filterItems(res, 'CK')
        //Asigna permisos que inician con el codigo CK para solo guardar permisos de client konect
        Vue.prototype.$session.set('permisos', res)
        return true;
      })
      .catch(() => {
        Vue.prototype.$session.destroy();
        return false;
      });
  },
};
